import { useEffect, useState, useRef, useCallback } from "react";
import { IoIosArrowBack } from "react-icons/io";
import gsap from "gsap";
import "./carousel.css";



function Carousel({ delay = 3000, autoPlay = true, imgUrl}) {
  
  const {card_url_1,card_url_2,card_url_3,card_url_4} = imgUrl
  const imageArray = [card_url_1,card_url_2,card_url_3,card_url_4]
  const [midImage, setMidImage] = useState(0);
  const [rightImage, setRightImage] = useState(1);
  const [leftImage, setLeftImage] = useState(imageArray.length - 1);
  const intervalRef = useRef(null);

  // Update surrounding images when midImage changes
  useEffect(() => {
    const last = imageArray.length - 1;
    if (midImage === 0) {
      setLeftImage(last);
      setRightImage(1);
    } else if (midImage === last) {
      setRightImage(0);
      setLeftImage(last - 1);
    } else {
      setRightImage(midImage + 1);
      setLeftImage(midImage - 1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [midImage]);

  const animate = useCallback((dir = "next") => {
    const xDir = dir === "next" ? -200 : 200;
    gsap.fromTo(".middleImage", { x: xDir, opacity: 0, scale: 0.6 }, { x: 0, opacity: 1, scale: 1, duration: 0.5 });
    gsap.fromTo(".rightImage", { x: 600, opacity: 0, scale: 0.6 }, { x: 0, opacity: 1, scale: 1, duration: 0.5 });
    gsap.fromTo(".leftImage", { x: -500, opacity: 0, scale: 0.6 }, { x: 0, opacity: 1, scale: 1, duration: 0.5 });
  }, []);

  // Advance slide forward
  const increment = useCallback(() => {
    setMidImage(prev => (prev === imageArray.length - 1 ? 0 : prev + 1));
    animate("next");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animate]);

  // Advance slide backward
  const decrement = useCallback(() => {
    setMidImage(prev => (prev === 0 ? imageArray.length - 1 : prev - 1));
    animate("prev");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animate]);

  // Manage autoplay interval
  const resetInterval = useCallback(() => {
    if (autoPlay) {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(increment, delay);
    }
  }, [autoPlay, delay, increment]);

  // Set up autoplay on mount & midImage change
  useEffect(() => {
    resetInterval();
    return () => clearInterval(intervalRef.current);
  }, [resetInterval]);

  // Handlers – reset autoplay after manual click
  const onNext = () => { increment(); resetInterval(); };
  const onPrev = () => { decrement(); resetInterval(); };

  return (
    <div className="ImageSlider">
      <div className="ImageSliderContainter">
        <div className="Images">
          <img src={imageArray[rightImage]} className="rightImage" alt="right" />
          <img src={imageArray[midImage]} className="middleImage" alt="middle" />
          <img src={imageArray[leftImage]} className="leftImage" alt="left" />
        </div>
      </div>
      <div className="buttons">
        <button className="leftButton" onClick={onPrev}>
          <IoIosArrowBack />
        </button>
        <button className="rightButton" onClick={onNext}>
          <IoIosArrowBack />
        </button>
      </div>
      <div className="dotsPlace">
        {imageArray.map((_, i) => (
          <div
            key={i}
            className={`dots ${i === midImage ? "active" : "passive"}`}
            onClick={() => { setMidImage(i); resetInterval(); }}
          />
        ))}
      </div>
    </div>
  );
}

export default Carousel;